import { Home, SearchX } from "lucide-react";
import { RENTAL } from "@/constants/testIds";

export const EmptyState = ({ filtered }) => {
  const Icon = filtered ? SearchX : Home;
  return (
    <div
      data-testid={RENTAL.emptyState}
      className="bg-white/60 border border-stone-200 rounded-3xl p-10 text-center"
    >
      <div className="mx-auto w-20 h-20 rounded-2xl bg-[#4A5D4E]/10 flex items-center justify-center text-[#4A5D4E]">
        <Icon size={36} strokeWidth={1.5} />
      </div>
      <h3 className="font-heading text-3xl font-medium tracking-tight mt-4">
        {filtered ? "No rentals match these filters" : "Your shortlist is empty"}
      </h3>
      <p className="text-stone-500 mt-2 max-w-md mx-auto">
        {filtered
          ? "Try loosening a constraint or two — your perfect place might be one filter away."
          : "Paste your first rental ad link above. We'll parse the price, beds, baths, and an image for you."}
      </p>
    </div>
  );
};

export default EmptyState;
